import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';


const useStyles = makeStyles(theme => ({
  benefitsTable: {
    //borderCollapse: 'collapse',
    borderSpacing: '1px 0',
    '& tbody>tr:nth-child(odd)': {  // alternate body rows
      background: theme.palette.common.paleGrey,
    },
    '& tbody>tr>td:nth-child(1)': {  // 1st column of body
      paddingTop: 5,
      paddingBottom: 5,
      paddingLeft: 10,
      color:  theme.palette.primary.main,
      fontWeight: 'bold',
    },
    '& td:nth-child(1n+2)': { // 2nd and 3rd column
      width: 130,
      textAlign: 'center',
      borderLeft: 1,
      borderRight: 1,
      borderTop: 0,
      borderBottom: 0,
      borderLeftColor: theme.palette.common.silver,
      borderRightColor: theme.palette.common.silver,
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      borderStyle: 'solid',
    },
    '& tfoot>tr>th:nth-child(1n+2)': { // 2nd and 3rd footer columns
      fontWeight: 'bold',
      color:  theme.palette.primary.main,
      borderBottomLeftRadius: 16,
      borderBottomRightRadius: 16,
      backgroundColor: theme.palette.common.silver,
      padding: '1rem',
    },
    '& thead>tr>th:nth-child(1n+2)': {  // 2nd and 3rd header columns
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      backgroundColor: theme.palette.common.silver,
    },
    '& thead>tr>th': { // all header columns
      fontWeight: 'bold',
      color:  theme.palette.primary.main,
      padding: '1rem',
      fontSize: 18,
    },
  },
  benefitYes: {
    color: theme.palette.primary.main,
  },
  benefitNo: {
    color: theme.palette.primary.main,
  },
  benefitValue: {
  },
  benefitAccredited: {
    fontSize: 16,
    display: 'inline-block',
    width: 24,
    height: 24,
    color: 'white',
    fontWeight: 'bold',
    background:  theme.palette.primary.main,
    borderRadius: '50%',
    borderWidth: 1,
    borderColor:  theme.palette.primary.main,
    borderStyle: 'solid',
  },
  benefitBasic: {
    fontSize: 16,
    display: 'inline-block',
    width: 24,
    height: 24,
    color:  theme.palette.primary.main,
    fontWeight: 'bold',
    background: 'white',
    borderRadius: '50%',
    borderWidth: 1,
    borderColor:  theme.palette.primary.main,
    borderStyle: 'solid',
  },
}));



const BenefitsTable = ({content}) => {
  const classes = useStyles();

  const classify = (value, accredited) => {
    switch (value) {
    case 'Y':
      return <td className={classes.benefitYes}><CheckCircleIcon/></td>;
    case 'N':
      return <td className={classes.benefitNo}></td>;
    default:
      return <td className={classes.benefitValue}><span className={accredited ? classes.benefitAccredited : classes.benefitBasic}>{value}</span></td>;
    }
  };

  return (
    <table className={classes.benefitsTable}>
      <thead>
        <tr>
          <th>{content.benefitsTableHeading}</th>
          <th>{content.benefitsBasicHeader}</th>
          <th>{content.benefitsAccreditedHeader}</th>
        </tr>
      </thead>
      <tbody>
        {content.benefits.map((benefit, key) => (
          <tr key={key}>
            <td>{benefit.benefit}</td>
            {classify(benefit.basic, false)}
            {classify(benefit.accredited, true)}
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <th></th>
          <th>{content.benefitsBasicFooter}</th>
          <th>{content.benefitsAccreditedFooter}</th>
        </tr>
      </tfoot>
    </table>
  );
};

BenefitsTable.propTypes = {
  content: PropTypes.object.isRequired,
};

export default BenefitsTable;
